import { Template } from "devextreme-react/core/template";
import DropDownButton, {
  DropDownButtonRef,
} from "devextreme-react/drop-down-button";
import { ListRef } from "devextreme-react/list";
import { useCallback, useRef } from "react";
import type { UserPanelProps } from "../../types";
import { UserMenuSection } from "../user-menu-section/UserMenuSection";
import "./UserPanel.scss";

export const UserPanel = ({ menuMode }: UserPanelProps) => {
  const dropDownButtonRef = useRef<DropDownButtonRef>(null);
  const listRef = useRef<ListRef>(null);

  const dropDownButtonContentReady = useCallback(
    ({ component }) => {
      component.registerKeyHandler("downArrow", () => {
        listRef.current?.instance().focus();
      });
    },
    [listRef]
  );

  return (
    <div
      className="user-panel"
      onDoubleClick={() => dropDownButtonRef.current?.instance().close()}
    >
      {menuMode === "context" && (
        <>
          <DropDownButton
            ref={dropDownButtonRef}
            stylingMode="text"
            showArrowIcon={false}
            elementAttr={{
              class: "user-button",
            }}
            dropDownOptions={{
              width: "auto",
            }}
            dropDownContentTemplate="dropDownTemplate"
            onContentReady={dropDownButtonContentReady}
            icon="user"
          >
            <Template name="dropDownTemplate">
              <UserMenuSection
                dropDownButtonRef={dropDownButtonRef}
                listRef={listRef}
              />
            </Template>
          </DropDownButton>
        </>
      )}
      {menuMode === "list" && <UserMenuSection />}
    </div>
  );
};
